import React from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Grid, IconButton, Box } from '@mui/material';
import { MenuOutlined } from '@mui/icons-material';

import { Logo } from '../assets/icons';

import UserDropdownMenu from './UserDropDownMenu';
import LanguageSelection from './LanguageSelection';
import { useNavigate } from 'react-router';

const TopBar = ({ handleDrawerToggle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints?.down('md'));
  const navigate = useNavigate();

  return (
    <>
      <Grid
        item
        sx={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
        }}>
        {isMobile && (
          <IconButton
            aria-label='open drawer'
            edge='start'
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' }, color: theme.palette?.white?.main }}>
            <MenuOutlined fontSize='large' />
          </IconButton>
        )}
        <Box
          onClick={() => navigate('/')}
          sx={{
            cursor: 'pointer',
            '& svg': {
              width: isMobile ? theme.spacing(16) : '100%',
            },
          }}>
          <Logo />
        </Box>
      </Grid>
      <Grid
        item
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
        }}>
        <LanguageSelection />
        {<UserDropdownMenu />}
      </Grid>
    </>
  );
};

export default TopBar;
